export interface DictionaryFuelFeeRecord {
    id: number;
    name: string;
    sapName: string;
}